module.exports = __webpack_public_path__ + "img/2018-09-6.9e2f4aff.jpeg";